// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1thzq","empty":"ModalGraph_empty__Ovucq"};